var _g, _path, _path2, _defs, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_1_",
    style: {
      fill: "#F0F0F0"
    },
    cx: 250,
    cy: 342.331,
    rx: 239.756,
    ry: 138.423
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_2_",
    style: {
      fill: "#E0E0E0"
    },
    cx: 393.247,
    cy: 339.968,
    rx: 43.59,
    ry: 25.167
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_11_",
    style: {
      fill: "#E0E0E0"
    },
    points: "115.001,357.806 309.98,470.381 399.345,418.786 204.325,306.188  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_18_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M80.34,380.009l-40.352-23.298c-1.196-0.69-1.196-1.81,0-2.5l141.904-81.928 c1.196-0.69,3.134-0.69,4.33,0l40.351,23.298c1.196,0.69,1.196,1.81,0,2.5L84.67,380.009 C83.474,380.699,81.535,380.699,80.34,380.009z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_10_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15219_",
    style: {
      fill: "#37474F"
    },
    d: "M207.905,24.664L88.134,93.804c-2.398,1.393-4.35,4.773-4.35,7.548v270.105 c0,2.775,1.953,3.905,4.35,2.512l119.771-69.141c2.398-1.393,4.35-4.773,4.35-7.548V27.176 C212.256,24.401,210.303,23.271,207.905,24.664z M205.986,272.393c0,2.375-1.667,3.889-3.734,5.077L93.352,340.341 c-2.055,1.188-3.734,0.228-3.734-2.158V126.599c0-2.386,1.678-5.275,3.734-6.474l108.901-62.86 c2.066-1.199,3.734-0.228,3.734,2.147V272.393z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15214_",
    style: {
      fill: "#263238"
    },
    d: "M87.591,374.243c-2.415,1.111-5.931,1.014-8.174-0.27l-4.982-2.879 c-2.415-1.391-4.367-4.755-4.367-7.548V93.459c0-1.057,0.28-2.178,0.755-3.257c0.151-0.356,0.324-0.701,0.518-1.046 c0.011,0,0.011-0.011,0.011-0.011l13.705,7.915h0.011c-0.291,0.518-0.55,1.057-0.755,1.596 c-0.334,0.906-0.528,1.833-0.528,2.696v270.109C83.785,374.017,85.445,375.182,87.591,374.243z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15211_",
    style: {
      fill: "#27DEBF"
    },
    d: "M149.055,315.663c3.798-2.193,6.876-0.415,6.876,3.97 c0,4.385-3.078,9.717-6.876,11.91c-3.798,2.193-6.876,0.415-6.876-3.97S145.257,317.856,149.055,315.663z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15208_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15210_",
    d: "M148.02,65.059c1.613-0.931,2.92-0.176,2.92,1.686c0,1.862-1.307,4.126-2.92,5.057 c-1.613,0.931-2.92,0.176-2.92-1.686C145.099,68.255,146.407,65.99,148.02,65.059z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15209_",
    d: "M136.747,82.82l22.544-13.016c1.345-0.777,2.435-0.225,2.435,1.232c0,1.457-1.09,3.268-2.435,4.044 l-22.545,13.016c-1.345,0.777-2.435,0.225-2.435-1.232C134.312,85.407,135.403,83.596,136.747,82.82z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15207_",
    style: {
      fill: "#27DEBF",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M205.986,272.171 c0,2.375-1.667,3.889-3.734,5.077L93.352,340.119c-2.055,1.187-3.734,0.228-3.734-2.158V126.377c0-2.387,1.678-5.276,3.734-6.474 l108.901-62.86c2.066-1.199,3.734-0.228,3.734,2.147V272.171z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15204_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15206_",
    style: {
      fill: "#455A64"
    },
    d: "M212.213,26.485c-0.313-2.264-2.124-3.084-4.302-1.822L88.13,93.804 c-1.197,0.69-2.286,1.887-3.073,3.257l-13.705-7.915c0.798-1.37,1.876-2.545,3.084-3.235l119.759-69.153 c2.394-1.391,6.297-1.391,8.713,0l5.003,2.868C210.11,20.91,211.933,23.854,212.213,26.485z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.08,154.982c1.247-0.72,2.387-1.092,3.417-1.117c1.029-0.023,1.92,0.264,2.671,0.859 c0.75,0.598,1.338,1.49,1.763,2.678c0.425,1.188,0.664,2.615,0.718,4.281c0.02,0.574,0.028,1.105,0.028,1.592 c0,0.487,0,0.954,0,1.399s0,0.904,0,1.378c0,0.474-0.009,0.994-0.028,1.561c-0.054,1.758-0.289,3.465-0.704,5.125 c-0.416,1.659-0.99,3.217-1.722,4.668c-0.732,1.453-1.606,2.758-2.618,3.912c-1.012,1.155-2.142,2.093-3.39,2.813l-7.322,4.229 c-0.198,0.114-0.37,0.102-0.515-0.037c-0.145-0.139-0.217-0.361-0.217-0.668v-26.973c0-0.306,0.072-0.611,0.217-0.918 c0.145-0.307,0.316-0.517,0.515-0.631L122.08,154.982z M125.632,164.414c-0.108-3.139-1.338-4.029-3.688-2.672l-2.765,1.597 v15.865l2.901-1.675c2.277-1.315,3.462-3.599,3.552-6.852c0.018-0.596,0.027-1.15,0.027-1.666c0-0.514,0-1.016,0-1.502 c0-0.488,0-0.982,0-1.482C125.659,165.525,125.649,164.988,125.632,164.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.313,142.724c0.361-0.208,0.637-0.214,0.827-0.018c0.189,0.197,0.32,0.428,0.394,0.691 l5.911,22.891c0.072,0.237,0.108,0.426,0.108,0.564c0,0.25-0.059,0.5-0.176,0.748c-0.117,0.25-0.258,0.421-0.42,0.515 l-3.417,1.973c-0.362,0.209-0.62,0.239-0.773,0.092c-0.153-0.147-0.248-0.322-0.284-0.524l-0.76-3.027l-7.213,4.165l-0.76,3.903 c-0.036,0.244-0.131,0.529-0.285,0.854c-0.154,0.326-0.411,0.592-0.773,0.801l-3.416,1.973c-0.163,0.094-0.303,0.086-0.421-0.028 c-0.117-0.112-0.176-0.295-0.176-0.546c0-0.139,0.036-0.368,0.108-0.688l5.912-29.717c0.071-0.347,0.203-0.729,0.393-1.145 c0.19-0.416,0.466-0.729,0.827-0.938L143.313,142.724z M138.92,163.506l4.394-2.536l-2.196-8.753L138.92,163.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.792,130.323c0.198-0.114,0.37-0.103,0.516,0.036c0.144,0.14,0.217,0.362,0.217,0.668v4.426 c0,0.307-0.073,0.613-0.217,0.919c-0.146,0.307-0.317,0.517-0.516,0.632l-4.772,2.756v21.418c0,0.307-0.073,0.613-0.218,0.919 c-0.145,0.306-0.316,0.517-0.515,0.632l-3.553,2.051c-0.199,0.115-0.371,0.102-0.516-0.037c-0.145-0.139-0.216-0.361-0.216-0.668 v-21.418l-4.773,2.756c-0.199,0.114-0.371,0.102-0.516-0.037c-0.145-0.139-0.217-0.361-0.217-0.668v-4.426 c0-0.307,0.071-0.612,0.217-0.919c0.145-0.306,0.316-0.517,0.516-0.632L164.792,130.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.1,123.794c0.361-0.208,0.637-0.214,0.827-0.019c0.189,0.197,0.32,0.428,0.394,0.691 l5.911,22.891c0.072,0.237,0.108,0.426,0.108,0.564c0,0.25-0.058,0.5-0.176,0.748c-0.117,0.25-0.258,0.421-0.42,0.515 l-3.417,1.973c-0.362,0.209-0.62,0.239-0.773,0.092c-0.153-0.147-0.248-0.322-0.284-0.524l-0.76-3.027l-7.213,4.165l-0.76,3.903 c-0.036,0.244-0.131,0.529-0.285,0.854c-0.154,0.326-0.411,0.592-0.772,0.801l-3.417,1.973c-0.163,0.094-0.303,0.086-0.421-0.028 c-0.117-0.112-0.176-0.295-0.176-0.546c0-0.139,0.036-0.368,0.108-0.688l5.912-29.717c0.071-0.347,0.203-0.729,0.393-1.145 c0.19-0.416,0.466-0.729,0.827-0.938L176.1,123.794z M171.707,144.576l4.394-2.536l-2.196-8.753L171.707,144.576z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_819_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_821_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M387.395,127.452c-6.351,0.298-8.529,1.509-11.853,5.425 c-3.246,3.823-18.912,32.854-18.912,32.854s2.939,8.24,9.371,7.539l12.028-19.394L387.395,127.452z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2128_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M388.236,127.465c0,0-4.561-0.595-7.815,0.582 c-3.254,1.177-4.88,3.532-7.121,6.954c-1.734,2.647-7.807,13.64-7.807,13.64s2.959,8.228,11.372,8.228L388.236,127.465z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Character_22_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    style: {
      fill: "#263238"
    },
    d: "M409.996,333.908v-1.376c-0.543,1.615-3.061,8.565-6.88,12.048 c-3.036,2.769-7.178,5.967-8.231,9.055c-1.096,3.211,5.763,4.289,8.6,3.787c3.296-0.583,7.56-2.453,9.88-5.305 c1.632-2.005,2.671-4.381,3.836-5.958c1.165-1.576,3.851-3.337,4.481-5.161c0.346-1.002-0.065-3.198-0.551-5.053 c-0.446-1.702-0.93-3.573-1.511-3.413c-0.001,0.208,0,1.049,0,1.049c-0.698,0.774-2.632,1.543-4.812,1.626 C413.401,335.261,409.985,334.982,409.996,333.908z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_809_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M400.369,347.015c0.942-0.84,1.889-1.661,2.749-2.445 c2.668-2.434,4.701-6.561,5.87-9.378c0.667-1.608,1.01-3.324,1.01-5.065v-5.486h9.625v8.929v0v0.001v0.238l-0.049,0.025 c-0.463,2-4.88,7.32-7.39,10.789c-1.682,2.326-4.878,5.284-8.698,5.794C399.867,350.901,398.017,349.76,400.369,347.015z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_806_",
    style: {
      fill: "#263238"
    },
    d: "M376.023,324.42v-1.376c-0.543,1.615-3.061,8.565-6.879,12.048 c-3.036,2.769-7.177,5.967-8.231,9.054c-1.096,3.211,5.763,4.29,8.6,3.787c3.296-0.584,7.56-2.454,9.88-5.305 c1.632-2.005,2.671-4.381,3.836-5.958c1.165-1.577,3.851-3.337,4.481-5.161c0.346-1.002-0.065-3.198-0.551-5.053 c-0.446-1.702-0.93-3.573-1.511-3.413c-0.002,0.207,0,1.049,0,1.049c-0.699,0.775-2.632,1.543-4.812,1.627 C379.427,325.773,376.011,325.494,376.023,324.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M366.395,337.527c0.941-0.841,1.889-1.661,2.748-2.445 c2.668-2.434,4.702-6.561,5.87-9.377c0.667-1.608,1.01-3.324,1.01-5.065v-5.486h9.625v8.929l0,0v0.001v0.238l-0.049,0.024 c-0.463,2-4.88,7.321-7.39,10.789c-1.682,2.326-4.878,5.284-8.697,5.794C365.893,341.413,364.043,340.272,366.395,337.527z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    style: {
      fill: "#455A64"
    },
    d: "M417.706,184.328c7.462,16.297-0.269,73.706-0.269,73.706 c0.224,2.645,3.248,7.849,4.375,19.488c1.331,13.753-2.089,48.287-2.089,48.287s-4.456,2.914-9.727,0.387 c0,0-9.173-52.01-10.898-65.684c-1.505-11.934-4.395-38.174-4.395-38.174l-4.643,38.109c0,0,2.108,6.685,2.601,11.778 c0.779,8.044-7.014,45.493-7.014,45.493s-3.321,1.218-9.625,0.29c0,0-2.757-49.697-3.483-59.386 c-1.22-16.272-0.467-67.046,2.518-76.678L417.706,184.328z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    style: {
      fill: "#37474F"
    },
    d: "M394.704,222.337l-2.423-15.137c0,0-10.249-2.123-14.897-6.493 c0,0,4.876,6.066,12.12,8.053l2.721,11.654l-1.854,37.492L394.704,222.337z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_800_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M404.544,127.709L404.544,127.709c2.838,0.195,3.785,0.126,5.844,0.337 c4.113,0.423,5.104,6.439,6.787,9.993c1.822,3.847,1.843,8.307,0.452,12.33l-6.666,19.285c0,0,3.121,7.545,6.745,14.673 c-16.729,9.337-37.618,4.429-42.649-2.385c-0.213-1.445,1.08-12.744,1.876-20.125c-2.946-7.391-3.724-12.076-2.481-16.962 c2.307-9.069,10.575-17.413,12.942-17.405L404.544,127.709z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1995_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M418.845,91.103l-3.462-0.301c0.416-0.238,0.779-0.58,1.03-1.034 c0.75-1.362,0.253-3.123-1.111-3.933l-2.233,4.054c-3.691-6.329-10.693-10.429-18.513-10.012l-1.786,0.095 c-11.136,0.593-19.682,10.101-19.089,21.236c0.613,11.504,1.29,24.372,1.29,24.372l20.775-1.106 c11.784-0.627,20.828-10.688,20.2-22.472l-0.154-3.036c-0.103-1.942-0.493-3.799-1.1-5.549c0.304,0.157,0.642,0.263,1.006,0.295 C417.247,93.845,418.656,92.678,418.845,91.103z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_677_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_797_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M377.409,102.558c-0.143,2.302-0.063,3.562,0.171,6.616 c0.792,10.352,4.288,12.733,6.014,13.382c1.726,0.648,4.956,0.026,8.09-0.669l-0.001,6.121c0,0-3.769,5.409-3.342,8.247 c0.427,2.838,6.499,3.19,10.442,0.186c3.942-3.004,5.541-8.114,5.541-8.114l-0.003-14.308c0,0,2.287,2.738,5.656,0.232 c3.369-2.506,3.196-8.253,1.056-10.206c-2.14-1.953-6.563-1.125-7.227,1.766c0,0-7.293-0.611-8.22-12.624 C388.809,102.025,377.839,95.651,377.409,102.558z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1993_",
    style: {
      fill: "#455A64"
    },
    d: "M403.764,105.01l0.273,5.129l0,0c-1.928,0.103-3.574-1.377-3.676-3.305 l-0.305-5.724L403.764,105.01z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_465_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_474_",
    style: {
      fill: "#263238"
    },
    d: "M390.379,105.635c0.002,0.749,0.588,1.353,1.309,1.349 c0.721-0.004,1.303-0.615,1.301-1.364c-0.002-0.749-0.588-1.353-1.309-1.348C390.959,104.276,390.377,104.886,390.379,105.635z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_456_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    style: {
      fill: "#F28F8F"
    },
    d: "M390.292,114.82l-3.49,1.321c0.349,1,1.413,1.516,2.377,1.151 C390.142,116.927,390.641,115.82,390.292,114.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_451_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_455_",
    style: {
      fill: "#455A64"
    },
    d: "M391.806,99.782l3.058,0.987c0.307-0.841-0.129-1.743-0.974-2.016 C393.045,98.48,392.112,98.941,391.806,99.782z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_363_",
    style: {
      fill: "#263238"
    },
    d: "M379.176,106.199c0.002,0.749,0.589,1.353,1.309,1.348 c0.721-0.004,1.303-0.615,1.301-1.363c-0.002-0.749-0.588-1.352-1.309-1.348C379.756,104.84,379.174,105.45,379.176,106.199z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_356_",
    style: {
      fill: "#F28F8F"
    },
    points: "386.79,105.093 387.001,112.95 382.803,111.891  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1996_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_347_",
    style: {
      fill: "#F28F8F"
    },
    d: "M391.684,121.886c3.31-0.615,10.063-2.95,10.987-5.718 c0,0-0.265,1.723-2.22,3.587c-1.955,1.865-8.767,4.205-8.767,4.205L391.684,121.886z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1994_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M400.266,186.137c5.495-1.301,6.539-3.371,5.088-8.828 c-0.055-0.207-0.112-0.385-0.171-0.526c-1.075-2.587-5.369-1.049-5.369-1.049s1.757-2.19,3.729-4.981 c1.972-2.791,2.855-7.408,3.118-10.646c0.264-3.238,0.792-9.725,0.792-9.725s4.274-2.558,2.608-7.238l6.6-4.055 c0,0,0.483,0.336,1.242,0.864c1.048,3.368,0.891,7.045-0.275,10.418l-6.666,19.285c0,0,3.938,6.935,6.745,14.673 c-12.329,6.881-26.91,6.022-35.745,2.368C388.94,187.778,395.406,187.288,400.266,186.137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    style: {
      fill: "#263238"
    },
    d: "M404.941,104.021l-7.557,0.402c-0.502-1.887-2.273-3.236-4.299-3.128 l-0.651,0.035c-1.755,0.093-3.201,1.253-3.753,2.816c-0.608-0.582-1.514-0.942-2.515-0.94c-0.875,0.002-1.619,0.282-2.14,0.764 c-0.788-1.258-2.202-2.076-3.786-1.991l-0.651,0.035c-2.323,0.124-4.111,2.114-3.988,4.437c0.124,2.323,2.114,4.112,4.436,3.988 l0.651-0.035c2.323-0.124,4.112-2.114,3.988-4.437c-0.025-0.47-0.144-0.909-0.309-1.324c0.378-0.45,1.033-0.725,1.8-0.727 c0.965-0.002,1.862,0.396,2.286,1.015l0.034-0.023c-0.042,0.279-0.057,0.565-0.042,0.857c0.124,2.323,2.114,4.112,4.436,3.988 l0.651-0.035c2.323-0.124,4.112-2.114,3.988-4.437c-0.003-0.053-0.019-0.101-0.024-0.154l6.759-0.36 C404.53,104.382,404.792,104.138,404.941,104.021z M380.651,109.694L380,109.729c-1.931,0.103-3.585-1.384-3.688-3.316 c-0.103-1.931,1.385-3.586,3.315-3.688l0.651-0.035c1.931-0.103,3.586,1.384,3.689,3.315 C384.07,107.937,382.582,109.591,380.651,109.694z M393.495,109.01l-0.651,0.035c-1.931,0.103-3.585-1.384-3.688-3.316 c-0.103-1.931,1.385-3.586,3.315-3.688l0.651-0.035c1.931-0.103,3.586,1.384,3.689,3.316 C396.914,107.253,395.426,108.908,393.495,109.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3993_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4063_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4065_",
    style: {
      fill: "#27DEBF"
    },
    points: "342.777,159.596 376.563,168.495 385.863,206.721 353.742,197.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4064_",
    style: {
      opacity: 0.25
    },
    points: "342.777,159.596 376.563,168.495 385.863,206.721 353.742,197.392  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M365.542,191.169c0.215,2.068,1.664,4.462,5.886,6.478c4.221,2.016,12.444,0.89,12.444,0.89 l-1.144-4.704L365.542,191.169z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4061_",
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4062_",
    d: "M358.043,186.666c-0.313,0.857-1.827,3.755-6.221,4.109l-0.342-1.178L358.043,186.666z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4055_",
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4056_",
    d: "M352.955,165.668c0,0-0.125-0.577-0.279-1.289c-0.154-0.712,1.829-0.742,4.429-0.068l4.978,1.291 c2.6,0.674,4.832,1.798,4.986,2.509l0.279,1.289L352.955,165.668z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4001_",
    style: {
      fill: "#37474F"
    },
    d: "M350.36,160.824c-0.098-0.445,0.705-0.561,1.794-0.261l1.971,0.544 c0,0-0.588-2.787,3.786-1.813c4.374,0.974,5.33,4.138,5.33,4.138s0.942,0.268,2.104,0.598c1.162,0.33,2.216,0.957,2.353,1.4 l0.249,0.802l-17.403-4.582C350.545,161.65,350.458,161.269,350.36,160.824z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3998_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3999_",
    style: {
      fill: "#37474F"
    },
    d: "M352.757,162.199c1.595,0.385,2.257,0.596,2.496,1.693 c0.272,1.253,0.383,2.173,0.383,2.173l7.703,2.036c0,0-0.372-1.587-0.491-2.205c-0.119-0.618,0.143-0.991,1.369-0.667 l0.104-0.491l-12.07-3.073L352.757,162.199z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3996_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3997_",
    style: {
      fill: "#37474F"
    },
    d: "M352.492,165.789c0,0-0.125-0.577-0.279-1.289 c-0.154-0.712,1.829-0.742,4.429-0.068l4.978,1.291c2.6,0.674,4.832,1.798,4.986,2.51l0.279,1.289L352.492,165.789z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3994_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3995_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M346.337,171.868c0,0,1.264,4.322,1.553,5.352 c0.289,1.03,4.074,2.882,6.558,3.564c2.483,0.682,5.2,1.491,4.024,4.963c-1.084,3.202-5.17,3.933-7.251,3.842 c-2.081-0.09-4.929-2.079-6.051-5.285c-1.431-4.089-0.66-8.456-1.229-10.845C343.373,171.072,345.093,170.444,346.337,171.868z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M409.622,127.977c4.381,0.278,8.91,2.65,9.597,7.912c0.687,5.262,4.948,32.96,3.276,36.078 c-3.867,7.211-29.368,20.923-31.902,22.096c-2.533,1.173-6.746,3.1-11.766,3.156c-3.977,0.044-9.268-0.086-11.944-3.682 c-2.374-3.19-3.716-9.079,1.648-8.066c5.364,1.013,12.292,0.54,12.292,0.54l-0.625-2.569c0,0,1.417-0.127,4.093,0.668 c2.676,0.795,5.108-1.503,9.833-4.422c6.094-3.765,15.368-11.725,15.368-11.725l-3.782-23.127 C405.712,144.836,405.586,134.838,409.622,127.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M408.829,127.977c0,0,2.344-0.539,4.919,0.441c2.575,0.981,4.861,2.286,5.93,7.471 c1.069,5.185,3.184,24.143,3.184,24.143s-5.611,4.056-14.747,2.129l-3.283-17.202 C404.832,144.959,402.275,132.918,408.829,127.977z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Analysis_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analysis"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "96.617,219.555 203.521,157.835 203.523,172.647 96.616,234.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "100.894,222.026 100.894,226.962 199.246,170.179 199.246,165.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "96.617,219.555 92.34,217.087 199.246,155.365 203.521,157.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "92.34,217.087 96.617,219.555 96.616,234.37 92.341,231.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_459_",
    style: {
      fill: "#37474F"
    },
    points: "404.508,412.157 310.421,466.442 310.421,464.031 404.497,409.747  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15053_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.625,263.771l-20.723,11.965l-12.738,7.348 c-0.411,0.211-0.811,0.442-1.2,0.695c-4.748,2.927-8.095,8.138-8.095,14.528l-0.011,59.55c0,5.79-2.758,10.633-6.832,13.664 c-2.937,2.2-6.559,3.463-10.306,3.463c-2.842,0-5.758-0.726-8.516-2.316c-15.875-9.169-25.655-26.107-25.655-44.435v-61.771 c0-9.169-2.442-17.991-6.874-25.655c-4.432-7.674-10.843-14.201-18.781-18.781l94.075-54.316l0,0 c7.948,4.59,14.359,11.138,18.791,18.801c4.432,7.674,6.874,16.486,6.874,25.655v26.908 C220.635,246.769,220.625,263.771,220.625,263.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M254.839,431.931c-15.875-9.159-25.655-26.097-25.655-44.425l-0.005-59.587 c0-6.969-1.411-13.717-4.032-19.928c-0.831-1.969-1.779-3.874-2.842-5.727c-4.432-7.664-10.843-14.191-18.78-18.77l0,0 c-11.404-6.577-25.652,1.658-25.645,14.823l0.003,6.069l-0.013-6.08l-0.011,59.55l0.002-12.39v12.368 c0,13.167-14.246,21.404-25.657,14.834c-15.875-9.169-25.655-26.107-25.655-44.435v-61.771c0-9.169-2.442-17.991-6.874-25.655 c-4.432-7.674-10.843-14.201-18.78-18.781v2.463c14.559,8.906,23.549,24.855,23.549,41.972v61.771 c0,19.023,10.232,36.74,26.707,46.257c6.011,3.474,13.191,3.474,19.212,0c0.368-0.21,0.726-0.432,1.084-0.674l0.032-0.021 c5.337-3.569,8.485-9.443,8.485-15.938l0.011-59.55c0-5.422,2.8-10.285,7.495-12.991c4.695-2.716,10.306-2.716,15.001,0 c9.485,5.474,16.728,13.906,20.823,23.739c2.453,5.895,3.779,12.296,3.779,18.865l0.001,13.826l0.004,45.761 c0,19.012,10.233,36.74,26.708,46.257l56.635,32.68v-2.411L254.839,431.931z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M404.497,409.747l-94.076,54.284l-55.583-32.1 c-15.875-9.159-25.655-26.097-25.655-44.425l-0.005-59.587c0-6.969-1.411-13.717-4.032-19.928 c-0.832-1.969-1.779-3.874-2.842-5.727c-4.432-7.664-10.843-14.191-18.781-18.77c-5.421-3.137-11.485-2.916-16.359-0.411 l12.738-7.348l25.628-14.797l54.857-31.666l0.137-0.084c4.979-2.874,11.38-3.274,17.075,0.01 c7.938,4.579,14.349,11.106,18.781,18.781c4.432,7.674,6.874,16.496,6.874,25.655l0.005,59.576 c0,18.328,9.78,35.266,25.655,44.435L404.497,409.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M227.073,327.919c0-6.569-1.326-12.97-3.779-18.865c-4.095-9.832-11.338-18.265-20.823-23.739 c-4.695-2.716-10.306-2.716-15.001,0c-4.695,2.706-7.495,7.569-7.495,12.991l-0.011,59.55c0,6.495-3.148,12.37-8.485,15.938 l-0.032,0.021c-0.358,0.242-0.716,0.463-1.084,0.674l56.711-32.744L227.073,327.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M227.073,327.919c0-6.569-1.326-12.97-3.779-18.865c-4.095-9.832-11.338-18.265-20.823-23.739 c-4.695-2.716-10.306-2.716-15.001,0c-4.695,2.706-7.495,7.569-7.495,12.991l-0.011,59.55c0,6.495-3.148,12.37-8.485,15.938 l-0.032,0.021c-0.358,0.242-0.716,0.463-1.084,0.674l56.711-32.744L227.073,327.919z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_300_",
    d: "M220.625,263.771l-20.723,11.965l-12.738,7.348c-0.411,0.211-0.811,0.442-1.2,0.695 c-4.748,2.927-8.095,8.138-8.095,14.528l-0.011,59.55c0,5.79-2.758,10.633-6.832,13.664c-2.937,2.2-6.559,3.463-10.306,3.463 c-2.842,0-5.758-0.726-8.516-2.316c-15.875-9.169-25.655-26.107-25.655-44.435v-61.771c0-9.169-2.442-17.991-6.874-25.655 c-4.432-7.674-10.843-14.201-18.781-18.781l94.075-54.316l0,0c7.948,4.59,14.359,11.138,18.791,18.801 c4.432,7.674,6.874,16.486,6.874,25.655v26.908C220.635,246.769,220.625,263.771,220.625,263.771z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000070826670202992523210000011234756620892856748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_300_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000070826670202992523210000011234756620892856748_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M117.603,222.322c1.98,1.692,5.47,2.055,7.988,0.602l67.13-38.758 c2.518-1.454,3.112-4.173,1.142-5.871c-1.97-1.698-5.744-1.727-8.262-0.274l-67.163,38.778 C115.92,218.253,115.623,220.63,117.603,222.322z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M171.727,207.662c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.387-18.122c0.358-0.206,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.387,18.122 C171.982,207.629,171.853,207.662,171.727,207.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M174.149,211.703c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.387-18.121c0.357-0.206,0.814-0.083,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.387,18.121 C174.404,211.67,174.275,211.703,174.149,211.703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M176.184,215.912c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.387-18.122c0.358-0.206,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.387,18.123 C176.439,215.88,176.311,215.912,176.184,215.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M177.819,220.289c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.386-18.121c0.358-0.204,0.813-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.386,18.121 C178.074,220.256,177.945,220.289,177.819,220.289z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M179.014,224.579c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.386-18.121c0.357-0.206,0.813-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.386,18.121 C179.268,224.546,179.14,224.579,179.014,224.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M179.821,229.19c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.386-18.122c0.358-0.205,0.814-0.083,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-31.386,18.122 C180.076,229.157,179.947,229.19,179.821,229.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M180.26,234.11c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l31.387-18.121c0.357-0.206,0.813-0.084,1.019,0.273c0.207,0.357,0.084,0.813-0.273,1.019l-31.387,18.121 C180.514,234.077,180.386,234.11,180.26,234.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M135.509,269.195c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.158-43.971c0.251-0.146,0.574-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.158,43.971 C135.689,269.172,135.598,269.195,135.509,269.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M135.509,273.896c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.158-43.972c0.251-0.147,0.574-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.158,43.972 C135.689,273.874,135.598,273.896,135.509,273.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M135.509,278.597c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.158-43.971c0.251-0.147,0.574-0.06,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.158,43.971 C135.689,278.574,135.598,278.597,135.509,278.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M135.509,283.298c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.158-43.971c0.251-0.147,0.574-0.06,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.158,43.971 C135.689,283.275,135.598,283.298,135.509,283.298z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M135.509,262.361c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l40.319-23.28c0.251-0.146,0.574-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-40.319,23.28 C135.689,262.338,135.598,262.361,135.509,262.361z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M134.372,235.369c1.598,3.188,2.905,6.366,3.734,9.528c0.905,2.898,1.432,6.473,1.746,10.429 c0.058,0.725,0.606,1.018,1.235,0.654l2.242-1.294c0.629-0.363,1.109-1.246,1.054-1.971 c-0.279-3.673-0.889-7.256-1.887-10.733c-1.083-3.465-2.26-6.622-3.608-9.22c-0.335-0.645-1.142-0.859-1.771-0.495 l-2.204,1.273C134.282,233.902,134.046,234.719,134.372,235.369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M141.022,226.062c2.048,3.183,3.853,7.002,5.396,11.502c1.243,3.614,2.061,7.789,2.408,12.587 c0.052,0.725,0.593,1.019,1.222,0.656l2.241-1.294c0.629-0.363,1.114-1.247,1.063-1.972c-0.305-4.276-1.142-8.46-2.451-12.564 c-1.403-4.226-3.202-8.02-5.359-11.425c-0.389-0.614-1.234-0.815-1.869-0.462l-2.23,1.24 C140.806,224.682,140.628,225.451,141.022,226.062z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M155.377,232.391"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M158.72,230.461l-2.203,1.272c-0.629,0.363-0.946,1.214-0.733,1.909 c1.016,3.318,1.694,7.083,2.001,11.337c0.052,0.725,0.592,1.018,1.222,0.655l2.241-1.294c0.629-0.363,1.114-1.248,1.063-1.973 c-0.274-3.839-0.976-7.605-2.065-11.305C160.04,230.365,159.349,230.098,158.72,230.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M167.684,221.517c-0.269-0.675-1.015-0.925-1.646-0.566l-2.22,1.263 c-0.632,0.359-0.912,1.192-0.642,1.867c0.402,1.006,0.789,2.051,1.161,3.136c1.243,3.614,2.061,7.789,2.408,12.587 c0.052,0.725,0.593,1.019,1.222,0.656l2.241-1.294c0.629-0.363,1.114-1.248,1.063-1.973c-0.305-4.275-1.141-8.46-2.451-12.564 C168.466,223.565,168.087,222.528,167.684,221.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M137.056,253.329c-0.103-0.18-0.332-0.24-0.509-0.137l-0.938,0.541 c-0.205-1.294-0.447-2.575-0.741-3.835l1.268-0.732c0.179-0.103,0.24-0.331,0.137-0.509c-0.103-0.18-0.334-0.241-0.509-0.137 l-1.086,0.627c-0.316-1.269-0.669-2.524-1.075-3.755l1.206-0.696c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.181-0.333-0.24-0.509-0.137l-1.087,0.627c-0.416-1.199-0.863-2.384-1.365-3.544 c-0.014-0.032-0.029-0.064-0.042-0.095l1.197-0.691c0.179-0.103,0.24-0.331,0.137-0.509c-0.103-0.181-0.332-0.241-0.509-0.137 l-1.129,0.652c-0.521-1.172-1.098-2.338-1.73-3.496l1.194-0.69c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.18-0.333-0.24-0.509-0.137l-1.183,0.683c-0.633-1.117-1.319-2.225-2.052-3.322l1.343-0.775 c0.179-0.103,0.24-0.331,0.137-0.509c-0.103-0.181-0.334-0.24-0.509-0.137l-1.389,0.802c-0.791-1.15-1.63-2.289-2.529-3.412 c-0.126-0.16-0.363-0.186-0.524-0.058c-0.16,0.128-0.186,0.363-0.058,0.524c0.875,1.093,1.692,2.201,2.463,3.319l-1.28,0.739 c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05l1.326-0.766 c0.735,1.098,1.422,2.205,2.054,3.322l-1.488,0.859c-0.179,0.103-0.239,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187 c0.064,0,0.127-0.016,0.186-0.05l1.476-0.852c0.633,1.158,1.208,2.324,1.728,3.497l-1.539,0.888 c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05l1.471-0.849 c0.002,0.005,0.004,0.009,0.006,0.014c0.514,1.187,0.972,2.401,1.394,3.63l-1.574,0.909c-0.179,0.103-0.24,0.331-0.137,0.509 c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.128-0.016,0.186-0.05l1.454-0.839c0.403,1.233,0.75,2.491,1.062,3.763 l-1.561,0.901c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05 l1.378-0.795c0.29,1.264,0.523,2.549,0.723,3.846l-1.689,0.975c-0.179,0.103-0.239,0.331-0.137,0.509 c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.128-0.017,0.186-0.05l1.443-0.833c0.218,1.574,0.369,3.17,0.454,4.787 c0.01,0.199,0.175,0.354,0.372,0.354c0.006,0,0.012,0,0.02-0.001c0.206-0.01,0.364-0.186,0.353-0.392 c-0.091-1.74-0.264-3.456-0.507-5.147l1.184-0.683C137.098,253.735,137.159,253.507,137.056,253.329z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M140.875,326.416c-0.31-2.809-0.425-5.656-0.339-8.478 c0.306-1.085,4.848-16.674,13.204-21.532c0.594-0.35,1.147-0.581,1.647-0.689c0.242-0.055,0.47-0.081,0.684-0.081 c2.215,0,3.208,3.082,4.17,6.063c0.4,1.242,0.814,2.526,1.319,3.584c0.569,1.198,1.539,2.791,3.382,2.791 c0.703,0,1.452-0.231,2.29-0.707c4.017-2.288,5.172-8.486,6.395-15.05c0.551-2.961,1.122-6.022,1.973-8.692 c1.218-3.83,2.798-6.202,4.974-7.463c0.699-0.403,1.324-0.608,1.859-0.608c2.329,0,3.21,4.148,4.062,8.159 c0.467,2.197,0.949,4.469,1.692,6.145c0.849,1.933,1.966,2.873,3.41,2.873c0.737,0,1.526-0.248,2.409-0.757 c4.93-2.846,6.422-7.67,7.865-12.336c1.225-3.961,2.382-7.702,5.634-9.594c0.863-0.505,1.677-0.76,2.418-0.76 c0.367,0,0.725,0.063,1.064,0.188c0.155,1.279,0.157,2.223,0.157,2.233l0.053,9.446c0.088,1.805,0.209,3.226,0.375,4.446 L140.875,326.416z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.144,285.876c-0.211-1.411-0.337-3.011-0.421-4.727l-0.053-9.443c0,0,0-1.116-0.2-2.6 c-0.47-0.222-0.986-0.347-1.548-0.347l0,0c-0.798,0-1.69,0.251-2.684,0.831c-7.253,4.221-4.485,16.728-13.496,21.928 c-0.82,0.473-1.528,0.686-2.145,0.686c-1.344,0-2.251-1.015-2.93-2.56c-2.121-4.785-2.063-14.616-6.235-14.616 c-0.61,0-1.312,0.21-2.123,0.678c-2.579,1.495-4.127,4.348-5.211,7.759c-2.684,8.422-2.527,20.254-8.127,23.444 c-0.779,0.442-1.448,0.638-2.03,0.638c-1.332,0-2.211-1.027-2.907-2.491c-1.733-3.633-2.342-9.947-5.963-9.947 c-0.25,0-0.515,0.03-0.795,0.094c-0.537,0.116-1.137,0.358-1.8,0.747c-8.906,5.179-13.464,21.907-13.464,21.907 c-0.101,3.214,0.053,6.349,0.434,9.414l1.032-0.596c-0.054-0.291-0.104-0.547-0.162-1.122 c-0.242-2.5-0.328-5.028-0.255-7.535c0.422-1.475,4.887-16.472,12.949-21.16c0.545-0.32,1.046-0.53,1.499-0.628 c0.199-0.045,0.388-0.068,0.563-0.068c1.831,0,2.765,2.897,3.668,5.698c0.406,1.258,0.825,2.559,1.344,3.648 c0.363,0.765,1.469,3.092,3.858,3.092c0.797,0,1.631-0.254,2.551-0.776c4.229-2.409,5.406-8.724,6.652-15.41 c0.549-2.945,1.117-5.991,1.958-8.63c1.176-3.698,2.68-5.976,4.733-7.165c0.619-0.357,1.156-0.538,1.597-0.538 c1.902,0,2.776,4.113,3.547,7.741c0.472,2.224,0.961,4.523,1.725,6.246c0.93,2.116,2.24,3.189,3.893,3.189 c0.832,0,1.705-0.271,2.671-0.827c5.109-2.949,6.701-8.096,8.105-12.637c1.193-3.859,2.321-7.505,5.395-9.294 c0.781-0.456,1.506-0.688,2.153-0.688l0,0c0.2,0,0.393,0.021,0.58,0.065c0.113,1.067,0.115,1.822,0.115,1.835l0.054,9.489 c0.08,1.628,0.187,2.958,0.333,4.117c0.066,0.503,0.135,0.883,0.203,1.097L212.144,285.876"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M140.015,313.092v4.766c-0.094,3.257,0.04,6.347,0.43,9.413l71.694-41.394 c-0.207-1.408-0.337-3.011-0.422-4.733l-0.051-9.437c0,0,0-14.103-8.96-8.93c-9.418,5.437-6.754,22.704-13.44,26.564 c-6.745,3.894-4.48-11.516-13.439-6.343c-8.96,5.173-4.48,16.689-13.44,21.863c-8.96,5.173-4.48-20.918-13.44-15.745 S139.988,307.135,140.015,313.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M136.733,334.546c-0.13,0-0.255-0.068-0.324-0.188c-0.102-0.179-0.04-0.406,0.139-0.509 l76.257-43.664c0.179-0.101,0.407-0.04,0.509,0.139c0.102,0.179,0.04,0.406-0.139,0.509l-76.257,43.664 C136.859,334.53,136.796,334.546,136.733,334.546z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M148.947,291.628c-0.206,0-0.373-0.168-0.373-0.373l0.001-0.746 c0-0.206,0.168-0.373,0.373-0.373s0.373,0.168,0.373,0.373l-0.001,0.746C149.32,291.461,149.153,291.628,148.947,291.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.162,320.31c-0.191,0-0.354-0.146-0.371-0.339c-0.044-0.476-0.081-0.957-0.111-1.439 c-0.013-0.206,0.143-0.383,0.349-0.396c0.244-0.026,0.383,0.144,0.396,0.348c0.03,0.476,0.067,0.949,0.109,1.419 c0.02,0.206-0.132,0.387-0.337,0.405C149.185,320.309,149.173,320.31,149.162,320.31z M148.987,317.449 c-0.204,0-0.37-0.164-0.373-0.368c-0.006-0.413-0.011-0.894-0.016-1.437c-0.001-0.207,0.165-0.374,0.37-0.376 c0.224-0.04,0.374,0.165,0.376,0.37c0.004,0.541,0.009,1.02,0.015,1.433c0.003,0.206-0.161,0.375-0.368,0.378 C148.992,317.449,148.989,317.449,148.987,317.449z M148.963,314.58c-0.205,0-0.371-0.165-0.373-0.371l-0.007-1.436 c-0.001-0.206,0.165-0.373,0.372-0.374h0.001c0.206,0,0.372,0.167,0.373,0.372l0.007,1.434 c0.001,0.206-0.165,0.373-0.371,0.375C148.965,314.58,148.964,314.58,148.963,314.58z M148.949,311.711 c-0.206,0-0.372-0.167-0.373-0.372l-0.003-1.434c0-0.207,0.167-0.373,0.372-0.374h0.001c0.206,0,0.372,0.167,0.373,0.372 l0.003,1.434c0,0.207-0.166,0.373-0.372,0.374H148.949z M148.943,308.842c-0.206,0-0.373-0.168-0.373-0.373l-0.001-1.434 c0-0.206,0.168-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373l0.001,1.434 C149.316,308.674,149.149,308.842,148.943,308.842z M148.94,305.973c-0.206,0-0.373-0.168-0.373-0.373v-1.434 c0-0.206,0.168-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373v1.434C149.313,305.805,149.146,305.973,148.94,305.973z  M148.94,303.104c-0.206,0-0.373-0.167-0.373-0.373v-1.434c0-0.206,0.168-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373 v1.434C149.313,302.937,149.146,303.104,148.94,303.104z M148.94,300.235h-0.001c-0.206-0.001-0.372-0.168-0.372-0.374 l0.001-1.433c0-0.206,0.168-0.373,0.373-0.373s0.373,0.167,0.373,0.373l-0.001,1.435 C149.312,300.068,149.146,300.235,148.94,300.235z M148.942,297.367L148.942,297.367c-0.207-0.001-0.373-0.168-0.373-0.374 l0.001-1.434c0-0.206,0.167-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373l-0.001,1.436 C149.314,297.2,149.148,297.367,148.942,297.367z M148.944,294.499c-0.206,0-0.373-0.168-0.373-0.373l0.002-1.43 c0.001-0.206,0.168-0.375,0.373-0.375c0,0,0,0,0.001,0c0.206,0.001,0.372,0.164,0.372,0.371l-0.002,1.434 C149.317,294.331,149.15,294.499,148.944,294.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.405,322.471c-0.184,0-0.344-0.137-0.37-0.324c-0.033-0.248-0.065-0.497-0.094-0.745 c-0.025-0.204,0.122-0.39,0.327-0.413c0.206-0.022,0.391,0.122,0.413,0.327c0.029,0.245,0.061,0.489,0.093,0.733 c0.027,0.203-0.116,0.392-0.321,0.419C149.438,322.47,149.421,322.471,149.405,322.471z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.715,263.898c-0.206,0-0.373-0.168-0.373-0.373l0.001-0.748 c0.001-0.205,0.168-0.371,0.373-0.371h0.001c0.207,0.001,0.373,0.169,0.372,0.374l-0.001,0.745 C203.088,263.73,202.921,263.898,202.715,263.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.93,292.579c-0.191,0-0.354-0.146-0.371-0.339c-0.044-0.476-0.081-0.957-0.111-1.439 c-0.013-0.206,0.143-0.383,0.348-0.396c0.231-0.012,0.382,0.145,0.396,0.349c0.03,0.476,0.067,0.949,0.109,1.419 c0.02,0.206-0.132,0.387-0.337,0.405C202.953,292.578,202.941,292.579,202.93,292.579z M202.755,289.719 c-0.204,0-0.37-0.163-0.373-0.368c-0.006-0.413-0.011-0.894-0.015-1.437c-0.001-0.207,0.165-0.374,0.37-0.376 c0.001,0,0.002,0,0.003,0c0.204,0,0.371,0.166,0.373,0.37c0.004,0.541,0.009,1.02,0.015,1.433 c0.003,0.206-0.161,0.375-0.368,0.378C202.759,289.719,202.757,289.719,202.755,289.719z M202.73,286.849 c-0.205,0-0.371-0.165-0.373-0.371l-0.007-1.436c-0.001-0.206,0.165-0.373,0.372-0.374h0.001 c0.206,0,0.372,0.167,0.373,0.372l0.007,1.434c0.001,0.206-0.165,0.373-0.371,0.375 C202.732,286.849,202.731,286.849,202.73,286.849z M202.717,283.979c-0.206,0-0.372-0.167-0.373-0.372l-0.003-1.434 c0-0.207,0.167-0.373,0.372-0.374h0.001c0.206,0,0.372,0.167,0.373,0.372l0.003,1.434c0,0.207-0.166,0.373-0.372,0.374 H202.717z M202.711,281.111c-0.206,0-0.373-0.168-0.373-0.373l-0.001-1.434c0-0.206,0.167-0.373,0.373-0.373 c0.206,0,0.373,0.168,0.373,0.373l0.001,1.434C203.084,280.944,202.917,281.111,202.711,281.111z M202.708,278.242 c-0.206,0-0.373-0.168-0.373-0.373v-1.434c0-0.206,0.168-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373v1.434 C203.081,278.074,202.914,278.242,202.708,278.242z M202.708,275.375c-0.206,0-0.373-0.168-0.373-0.373v-1.434 c0-0.206,0.168-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373v1.434C203.081,275.207,202.914,275.375,202.708,275.375z  M202.708,272.504L202.708,272.504c-0.207-0.001-0.373-0.168-0.373-0.374l0.001-1.433c0-0.206,0.168-0.373,0.373-0.373 s0.373,0.168,0.373,0.373l-0.001,1.435C203.08,272.338,202.914,272.504,202.708,272.504z M202.709,269.636h-0.001 c-0.206-0.001-0.372-0.168-0.372-0.374l0.001-1.434c0-0.206,0.167-0.373,0.373-0.373c0.206,0,0.373,0.168,0.373,0.373 l-0.001,1.436C203.081,269.47,202.915,269.636,202.709,269.636z M202.712,266.768L202.712,266.768 c-0.207-0.001-0.373-0.168-0.373-0.374l0.001-1.434c0-0.206,0.168-0.373,0.373-0.373s0.373,0.168,0.373,0.373l-0.001,1.436 C203.084,266.601,202.918,266.768,202.712,266.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.173,294.74c-0.184,0-0.344-0.137-0.37-0.324c-0.033-0.247-0.065-0.496-0.095-0.743 c-0.025-0.205,0.121-0.391,0.325-0.415c0.219-0.03,0.391,0.121,0.415,0.325c0.03,0.246,0.062,0.49,0.095,0.735 c0.027,0.204-0.116,0.392-0.321,0.419C203.206,294.739,203.189,294.74,203.173,294.74z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.828,285.41c-0.206,0-0.373-0.168-0.373-0.373v-0.746c0-0.206,0.168-0.373,0.373-0.373 c0.206,0,0.373,0.168,0.373,0.373v0.746C176.201,285.243,176.033,285.41,175.828,285.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.044,304.991c-0.191,0-0.354-0.145-0.371-0.338c-0.044-0.467-0.08-0.935-0.11-1.406 c-0.013-0.206,0.143-0.382,0.349-0.396c0.24-0.016,0.383,0.144,0.396,0.348c0.03,0.464,0.066,0.925,0.108,1.384 c0.02,0.206-0.132,0.387-0.336,0.406C176.066,304.99,176.055,304.991,176.044,304.991z M175.867,302.197 c-0.204,0-0.37-0.164-0.373-0.369l-0.016-1.399c-0.002-0.207,0.163-0.375,0.369-0.377c0.002,0,0.003,0,0.004,0 c0.205,0,0.371,0.164,0.373,0.369l0.016,1.399c0.002,0.206-0.163,0.374-0.369,0.377 C175.87,302.197,175.868,302.197,175.867,302.197z M175.839,299.401c-0.204,0-0.371-0.166-0.373-0.371l-0.007-1.4 c-0.001-0.207,0.165-0.374,0.371-0.375c0.001,0,0.002,0,0.002,0c0.206,0,0.372,0.167,0.373,0.371l0.007,1.4 c0.001,0.206-0.164,0.373-0.371,0.375C175.841,299.401,175.84,299.401,175.839,299.401z M175.828,296.602 c-0.206,0-0.372-0.167-0.373-0.372l-0.003-1.399c0-0.207,0.167-0.373,0.372-0.374h0.001c0.206,0,0.372,0.167,0.373,0.372 l0.003,1.399c0,0.207-0.167,0.373-0.372,0.374H175.828z M175.824,293.805c-0.206,0-0.373-0.168-0.373-0.373v-1.4 c0-0.206,0.168-0.373,0.373-0.373s0.373,0.168,0.373,0.373v1.4C176.197,293.637,176.029,293.805,175.824,293.805z  M175.824,291.006h-0.001c-0.206-0.001-0.372-0.168-0.372-0.374l0.001-1.398c0-0.206,0.167-0.373,0.373-0.373 c0.206,0,0.373,0.168,0.373,0.373l-0.001,1.4C176.196,290.84,176.029,291.006,175.824,291.006z M175.826,288.208h-0.001 c-0.206-0.001-0.372-0.167-0.372-0.374l0.001-1.398c0-0.206,0.168-0.373,0.373-0.373s0.373,0.168,0.373,0.373l-0.001,1.4 C176.198,288.041,176.031,288.208,175.826,288.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.284,307.121c-0.184,0-0.344-0.137-0.37-0.324c-0.033-0.247-0.065-0.495-0.095-0.745 c-0.025-0.205,0.121-0.39,0.326-0.414c0.201-0.031,0.39,0.121,0.414,0.326c0.03,0.246,0.062,0.49,0.095,0.735 c0.027,0.204-0.116,0.392-0.321,0.419C176.317,307.12,176.301,307.121,176.284,307.121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M148.94,287.639c0.712-0.411,1.289-0.139,1.289,0.609c0,0.747-0.577,1.686-1.289,2.097 c-0.712,0.411-1.289,0.139-1.289-0.609C147.65,288.989,148.228,288.05,148.94,287.639z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M175.827,281.418c0.712-0.411,1.289-0.139,1.289,0.609c0,0.747-0.577,1.686-1.289,2.097 c-0.712,0.411-1.289,0.139-1.289-0.608C174.538,282.769,175.115,281.83,175.827,281.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M202.706,261.425c0.712-0.411,1.289-0.139,1.289,0.608c0,0.747-0.577,1.686-1.289,2.097 c-0.712,0.411-1.289,0.139-1.289-0.609C201.417,262.775,201.994,261.836,202.706,261.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M137.229,296.321c0.179-0.103,0.24-0.331,0.137-0.509c-0.104-0.18-0.333-0.241-0.509-0.137 l-0.975,0.563v-3.85l1.348-0.778c0.179-0.103,0.24-0.331,0.137-0.509c-0.104-0.18-0.333-0.241-0.509-0.137l-0.976,0.563v-4.055 c0-0.206-0.168-0.373-0.373-0.373c-0.206,0-0.373,0.168-0.373,0.373v4.486l-1.351,0.78c-0.179,0.103-0.24,0.331-0.137,0.509 c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05l0.979-0.565v3.85l-1.352,0.78 c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.128-0.016,0.186-0.05l0.98-0.565v3.85 l-1.353,0.781c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.128-0.017,0.186-0.05 l0.981-0.566v3.849l-1.354,0.782c-0.179,0.103-0.239,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187 c0.064,0,0.128-0.016,0.186-0.05l0.982-0.567v3.85l-1.355,0.782c-0.179,0.103-0.24,0.331-0.137,0.509 c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05l0.983-0.567v3.85l-1.356,0.783 c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.017,0.186-0.05l0.984-0.568v3.849 l-1.357,0.784c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.128-0.016,0.186-0.05 l0.978-0.565c-0.023,1.279-0.011,2.555,0.044,3.824l-1.395,0.805c-0.179,0.103-0.24,0.331-0.137,0.509 c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.017,0.186-0.05l1.069-0.617c0.08,1.401,0.2,2.792,0.374,4.164 c0.024,0.188,0.185,0.326,0.37,0.326c0.015,0,0.031-0.001,0.047-0.003c0.204-0.026,0.349-0.213,0.323-0.417 c-0.188-1.475-0.317-2.974-0.394-4.485l1.284-0.741c0.179-0.103,0.24-0.331,0.137-0.509c-0.104-0.18-0.333-0.24-0.509-0.137 l-0.943,0.544c-0.047-1.272-0.06-2.551-0.028-3.834l1.344-0.776c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.181-0.333-0.24-0.509-0.137l-0.969,0.56v-3.849l1.343-0.775c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.18-0.332-0.241-0.509-0.137l-0.97,0.56v-3.85l1.344-0.775c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.18-0.333-0.24-0.509-0.137l-0.971,0.561v-3.85l1.345-0.777c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.181-0.333-0.24-0.509-0.137l-0.972,0.562v-3.849l1.346-0.777c0.179-0.103,0.24-0.331,0.137-0.509 c-0.104-0.181-0.332-0.24-0.509-0.137l-0.974,0.562v-3.85L137.229,296.321z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M230.663,319.417l-71.626,41.354c-2.518,1.454-6.167,1.281-7.971-0.575 c-1.804-1.855-1.066-4.685,1.452-6.138l71.605-41.342c2.518-1.454,5.866-0.983,7.675,0.869 C233.609,315.436,233.181,317.963,230.663,319.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M138.058,339.533c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l80.677-46.58c0.251-0.147,0.574-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-80.677,46.58 C138.238,339.51,138.148,339.533,138.058,339.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M139.707,343.895c-0.181,0-0.359-0.095-0.456-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l80.689-46.588c0.251-0.147,0.574-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-80.689,46.588 C139.887,343.872,139.797,343.895,139.707,343.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M141.743,348.077c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l80.7-46.593c0.252-0.147,0.575-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-80.7,46.593 C141.923,348.055,141.832,348.077,141.743,348.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M144.146,352.058c-0.181,0-0.359-0.095-0.456-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l80.711-46.6c0.251-0.147,0.575-0.06,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-80.711,46.6 C144.326,352.035,144.236,352.058,144.146,352.058z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M214.581,274.898l66.388-38.323c2.518-1.453,6.528-2.316,8.785-1.405 c2.257,0.911,1.825,3.27-0.693,4.724L221.9,278.662c-2.518,1.453-6.099,1.605-8.105,0.523 C211.79,278.103,212.064,276.351,214.581,274.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M222.28,285.435c-0.181,0-0.359-0.095-0.456-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.521-44.171c0.251-0.147,0.574-0.06,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.521,44.171 C222.46,285.413,222.369,285.435,222.28,285.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M225.449,288.857c-0.181,0-0.359-0.095-0.455-0.263c-0.146-0.252-0.06-0.574,0.192-0.719 l76.639-44.238c0.252-0.146,0.575-0.061,0.719,0.192c0.146,0.252,0.06,0.574-0.192,0.719l-76.639,44.238 C225.629,288.834,225.539,288.857,225.449,288.857z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M238.139,327.979L238.139,327.979c-0.207-0.001-0.373-0.168-0.373-0.374l0.014-4.06 c0.012-3.057,0.012-3.057-0.076-5.124l-0.016-0.342c-0.291-4.954-1.209-9.611-2.726-13.836 c-1.333-4.014-3.589-7.954-6.898-12.053c-0.13-0.16-0.105-0.395,0.055-0.524c0.16-0.129,0.396-0.105,0.524,0.056 c3.368,4.17,5.665,8.186,7.023,12.278c1.539,4.284,2.471,9.011,2.768,14.042l0.015,0.349c0.089,2.084,0.089,2.084,0.076,5.159 l-0.013,4.059C238.511,327.812,238.344,327.979,238.139,327.979z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M237.37,296.042c-0.34-0.598-0.708-1.186-1.1-1.765c-0.407-0.602-0.25-1.369,0.379-1.732 l29.24-16.88c0.629-0.363,1.483-0.179,1.863,0.441c0.352,0.576,0.685,1.181,1.011,1.815c0.332,0.646,0.074,1.474-0.555,1.837 l-29.078,16.786C238.5,296.908,237.73,296.674,237.37,296.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M240.216,302.777c0.219,0.672,0.42,1.336,0.602,1.994c0.194,0.7,0.842,0.979,1.472,0.616 l69.373-40.044c0.629-0.363,0.998-1.23,0.806-1.931c-0.19-0.694-0.388-1.361-0.592-2.001c-0.221-0.692-0.928-0.953-1.558-0.589 l-69.386,40.052C240.303,301.236,239.991,302.086,240.216,302.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M240.216,302.777c0.219,0.672,0.42,1.336,0.602,1.994 c0.194,0.7,0.842,0.979,1.472,0.616l69.373-40.044c0.629-0.363,0.998-1.23,0.806-1.931c-0.19-0.694-0.388-1.361-0.592-2.001 c-0.221-0.692-0.928-0.953-1.558-0.589l-69.386,40.052C240.303,301.236,239.991,302.086,240.216,302.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M242.236,312.01c0.09,0.738,0.165,1.458,0.222,2.155c0.059,0.724,0.594,1.019,1.224,0.656 l46.996-27.128c0.63-0.363,1.109-1.247,1.05-1.971c-0.059-0.72-0.133-1.436-0.221-2.148c-0.09-0.721-0.689-1.009-1.318-0.646 l-46.983,27.121C242.576,310.412,242.148,311.289,242.236,312.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M242.236,312.01c0.09,0.738,0.165,1.458,0.222,2.155c0.059,0.724,0.594,1.019,1.224,0.656 l46.996-27.128c0.63-0.363,1.109-1.247,1.05-1.971c-0.059-0.72-0.133-1.436-0.221-2.148c-0.09-0.721-0.689-1.009-1.318-0.646 l-46.983,27.121C242.576,310.412,242.148,311.289,242.236,312.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M242.618,321.592l0,2.113c0,0.727,0.51,1.021,1.14,0.658l20.12-11.614 c0.629-0.363,1.14-1.247,1.14-1.974v-2.114c0-0.727-0.51-1.021-1.14-0.658l-20.12,11.615 C243.128,319.982,242.618,320.866,242.618,321.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M242.618,321.592l0,2.113c0,0.727,0.51,1.021,1.14,0.658l20.12-11.614 c0.629-0.363,1.14-1.247,1.14-1.974v-2.114c0-0.727-0.51-1.021-1.14-0.658l-20.12,11.615 C243.128,319.982,242.618,320.866,242.618,321.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M314.295,288.184c-0.206,0-0.373,0.168-0.373,0.373v1.809l-5.362,3.095v-1.354 c0-0.206-0.168-0.373-0.373-0.373c-0.206,0-0.373,0.167-0.373,0.373v1.785l-5.362,3.095v-1.33c0-0.206-0.168-0.373-0.373-0.373 c-0.206,0-0.373,0.168-0.373,0.373v1.76l-5.362,3.095v-1.306c0-0.206-0.168-0.373-0.373-0.373c-0.206,0-0.373,0.167-0.373,0.373 v1.737l-5.363,3.096v-1.281c0-0.206-0.168-0.373-0.373-0.373c-0.205,0-0.373,0.168-0.373,0.373v1.712l-5.362,3.095v-1.257 c0-0.206-0.168-0.373-0.373-0.373s-0.373,0.168-0.373,0.373v1.688l-5.362,3.095v-1.234c0-0.206-0.168-0.373-0.373-0.373 c-0.206,0-0.373,0.168-0.373,0.373v1.664l-5.362,3.095v-1.21c0-0.206-0.168-0.373-0.373-0.373s-0.373,0.168-0.373,0.373v1.64 l-5.362,3.095v-1.185c0-0.206-0.168-0.373-0.373-0.373c-0.205,0-0.373,0.168-0.373,0.373v1.615l-5.362,3.095v-1.161 c0-0.206-0.168-0.373-0.373-0.373s-0.373,0.168-0.373,0.373v1.591l-5.362,3.095v-1.137c0-0.206-0.167-0.373-0.373-0.373 c-0.206,0-0.373,0.168-0.373,0.373v1.568l-5.363,3.096v-1.112c0-0.206-0.168-0.373-0.373-0.373c-0.206,0-0.373,0.168-0.373,0.373 v1.543l-4.654,2.686c-0.179,0.103-0.24,0.331-0.137,0.509c0.069,0.12,0.194,0.187,0.323,0.187c0.064,0,0.127-0.016,0.186-0.05 l4.282-2.471v1.514c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.945l5.363-3.096v1.491 c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.922l5.362-3.095v1.467c0,0.206,0.168,0.373,0.373,0.373 s0.373-0.168,0.373-0.373v-1.898l5.362-3.095v1.443c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.874 l5.362-3.095v1.418c0,0.206,0.167,0.373,0.373,0.373s0.373-0.168,0.373-0.373v-1.849l5.362-3.095v1.394 c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.825l5.362-3.095v1.37c0,0.206,0.168,0.373,0.373,0.373 s0.373-0.168,0.373-0.373v-1.801l5.362-3.095v1.345c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.776 l5.363-3.096v1.322c0,0.206,0.168,0.373,0.373,0.373c0.205,0,0.373-0.168,0.373-0.373v-1.753l5.362-3.095v1.298 c0,0.206,0.168,0.373,0.373,0.373c0.206,0,0.373-0.168,0.373-0.373v-1.729l5.362-3.095v1.274c0,0.206,0.168,0.373,0.373,0.373 c0.206,0,0.373-0.168,0.373-0.373v-1.705l5.362-3.095v1.249c0,0.206,0.168,0.373,0.373,0.373s0.373-0.168,0.373-0.373v-3.919 C314.669,288.352,314.501,288.184,314.295,288.184z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M255.495,337.375c-1.232,0.263-2.548,0.779-3.906,1.579 c-7.422,4.358-13.433,15.264-13.433,24.36c0,0.242,0,0.474,0.01,0.705l13.412-6.137L255.495,337.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M255.495,337.375l-3.916,20.507l13.296-7.716c0.095-0.832,0.147-1.663,0.147-2.484 C265.022,340.196,261.011,336.217,255.495,337.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M263.19,357.082c0.853-2.284,1.442-4.632,1.685-6.916l-13.296,7.716L263.19,357.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M238.167,364.019c0.305,8.601,6.201,12.191,13.422,8.022c4.958-2.863,9.285-8.674,11.601-14.959 l-11.611,0.8L238.167,364.019z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M255.495,337.375l-3.916,20.507l13.296-7.716c0.095-0.832,0.147-1.663,0.147-2.484 C265.022,340.196,261.011,336.217,255.495,337.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M263.19,357.082c0.853-2.284,1.442-4.632,1.685-6.916l-13.296,7.716L263.19,357.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M238.167,364.019c0.305,8.601,6.201,12.191,13.422,8.022 c4.958-2.863,9.285-8.674,11.601-14.959l-11.611,0.8L238.167,364.019z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.495,337.375c-1.232,0.263-2.548,0.779-3.906,1.579c-7.422,4.358-13.433,15.264-13.433,24.36c0,0.242,0,0.474,0.01,0.705 l13.412-6.137L255.495,337.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.495,337.375l-3.916,20.507l13.296-7.716c0.095-0.832,0.147-1.663,0.147-2.484 C265.022,340.196,261.011,336.217,255.495,337.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M263.19,357.082c0.853-2.284,1.442-4.632,1.685-6.916l-13.296,7.716L263.19,357.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M238.167,364.019c0.305,8.601,6.201,12.191,13.422,8.022c4.958-2.863,9.285-8.674,11.601-14.959l-11.611,0.8L238.167,364.019z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M294.782,315.678c-4.369,5.264-7.358,12.612-7.358,19.075c0,2.937,0.621,5.348,1.695,7.116 l11.738-14.885L294.782,315.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.92,308.636c-1.821-0.084-3.884,0.463-6.064,1.727c-2.19,1.263-4.253,3.105-6.074,5.316 l6.074,11.306L306.92,308.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M313.047,312.931c-1.274-2.653-3.442-4.169-6.127-4.295l-6.064,18.349L313.047,312.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M313.047,312.931l-12.191,14.054l-11.738,14.885c2.305,3.748,6.695,4.653,11.738,1.737 c7.422-4.285,13.443-15.201,13.443-24.391C314.3,316.71,313.847,314.594,313.047,312.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M306.92,308.636c-1.821-0.084-3.884,0.463-6.064,1.727 c-2.19,1.263-4.253,3.105-6.074,5.316l6.074,11.306L306.92,308.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M313.047,312.931c-1.274-2.653-3.442-4.169-6.127-4.295l-6.064,18.349L313.047,312.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M313.047,312.931l-12.191,14.054l-11.738,14.885 c2.305,3.748,6.695,4.653,11.738,1.737c7.422-4.285,13.443-15.201,13.443-24.391C314.3,316.71,313.847,314.594,313.047,312.931z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M294.782,315.678c-4.369,5.264-7.358,12.612-7.358,19.075c0,2.937,0.621,5.348,1.695,7.116l11.738-14.885L294.782,315.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.92,308.636c-1.821-0.084-3.884,0.463-6.064,1.727c-2.19,1.263-4.253,3.105-6.074,5.316l6.074,11.306L306.92,308.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M313.047,312.931c-1.274-2.653-3.442-4.169-6.127-4.295l-6.064,18.349L313.047,312.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0527,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M313.047,312.931l-12.191,14.054l-11.738,14.885c2.305,3.748,6.695,4.653,11.738,1.737c7.422-4.285,13.443-15.201,13.443-24.391 C314.3,316.71,313.847,314.594,313.047,312.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M270.641,327.844l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.113 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,329.091,270.012,328.207,270.641,327.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M270.641,337.328l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.113 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,338.574,270.012,337.691,270.641,337.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M270.641,337.328l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.113 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,338.574,270.012,337.691,270.641,337.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M270.641,346.811l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.114 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,348.058,270.012,347.174,270.641,346.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M270.641,346.811l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.114 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,348.058,270.012,347.174,270.641,346.811z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M270.641,356.294l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.113 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,357.541,270.012,356.657,270.641,356.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M270.641,356.294l2.2-1.27c0.629-0.363,1.14-0.069,1.14,0.658l0,2.113 c0,0.727-0.51,1.61-1.139,1.974l-2.2,1.27c-0.629,0.363-1.14,0.069-1.14-0.658l0-2.113 C269.501,357.541,270.012,356.657,270.641,356.294z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M276.242,327.626c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l6.697-3.866c0.357-0.206,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-6.697,3.865 C276.497,327.593,276.369,327.626,276.242,327.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M276.139,337.205c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.019 l6.697-3.865c0.358-0.206,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-6.697,3.865 C276.394,337.172,276.266,337.205,276.139,337.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M276.037,346.783c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.273-1.019 l6.697-3.865c0.358-0.205,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.019l-6.697,3.865 C276.292,346.75,276.163,346.783,276.037,346.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M275.933,356.36c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l6.697-3.864c0.36-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-6.697,3.864 C276.187,356.327,276.059,356.36,275.933,356.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M238.992,390.058c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.02 l31.358-18.098c0.36-0.205,0.813-0.084,1.02,0.272c0.206,0.357,0.083,0.813-0.273,1.02l-31.358,18.099 C239.246,390.025,239.118,390.058,238.992,390.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M240.003,394.7c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.358-18.098c0.361-0.206,0.814-0.083,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.02L240.375,394.6 C240.256,394.667,240.129,394.7,240.003,394.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M241.447,399.191c-0.258,0-0.509-0.134-0.647-0.373c-0.207-0.357-0.084-0.813,0.272-1.02 l31.359-18.098c0.361-0.206,0.813-0.084,1.02,0.272c0.206,0.357,0.083,0.813-0.273,1.02l-31.359,18.099 C241.701,399.158,241.573,399.191,241.447,399.191z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M288.214,361.652c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.358-18.099c0.361-0.204,0.814-0.083,1.019,0.273c0.207,0.357,0.084,0.813-0.272,1.02l-31.358,18.098 C288.468,361.619,288.34,361.652,288.214,361.652z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M289.223,366.293c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.359-18.098c0.361-0.206,0.814-0.084,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.02l-31.359,18.099 C289.477,366.26,289.35,366.293,289.223,366.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M290.669,370.784c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.359-18.098c0.361-0.206,0.814-0.083,1.019,0.272c0.207,0.357,0.084,0.813-0.272,1.02l-31.359,18.099 C290.923,370.751,290.795,370.784,290.669,370.784z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M250.055,404.28l71.492-41.259c2.518-1.453,5.626-0.81,7.162,1.284 c1.536,2.094,0.908,4.837-1.61,6.29l-71.516,41.272c-2.518,1.453-5.981,1.072-7.51-1.027 C246.542,408.743,247.537,405.733,250.055,404.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M261.851,424.498c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.355-18.096c0.36-0.202,0.814-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-31.355,18.096 C262.104,424.465,261.977,424.498,261.851,424.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M257.927,421.731c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.355-18.095c0.36-0.203,0.814-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02L258.3,421.631 C258.181,421.698,258.054,421.731,257.927,421.731z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M265.974,426.938c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.357-18.096c0.36-0.203,0.813-0.082,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-31.357,18.096 C266.228,426.905,266.1,426.938,265.974,426.938z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M306.62,398.662c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.357-18.096c0.361-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-31.357,18.096 C306.874,398.629,306.746,398.662,306.62,398.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M302.697,395.895c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.355-18.095c0.36-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-31.355,18.095 C302.951,395.862,302.823,395.895,302.697,395.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M310.743,401.102c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l31.357-18.096c0.36-0.203,0.813-0.082,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-31.357,18.096 C310.997,401.069,310.87,401.102,310.743,401.102z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M311.215,423.663c-6.808-3.932-18.344-3.647-25.766,0.636 c-7.422,4.283-7.92,10.943-1.112,14.874c6.808,3.932,18.344,3.647,25.766-0.636 C317.526,434.255,318.023,427.595,311.215,423.663z M306.581,436.504c-5.302,3.059-13.542,3.263-18.404,0.454 c-4.863-2.808-4.508-7.565,0.794-10.625c5.301-3.059,13.541-3.263,18.405-0.454 C312.238,428.688,311.883,433.444,306.581,436.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M292.493,428.367c3.181-1.836,8.125-1.958,11.043-0.273c2.918,1.685,2.705,4.539-0.476,6.375 s-8.125,1.958-11.043,0.272C289.099,433.057,289.312,430.203,292.493,428.367z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M292.493,428.367c3.181-1.836,8.125-1.958,11.043-0.273c2.918,1.685,2.705,4.539-0.476,6.375 s-8.125,1.958-11.043,0.272C289.099,433.057,289.312,430.203,292.493,428.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M311.215,423.663c-6.808-3.932-18.344-3.647-25.766,0.636c-7.422,4.283-7.92,10.943-1.112,14.874 c6.808,3.932,18.344,3.647,25.766-0.636C317.526,434.255,318.023,427.595,311.215,423.663z M306.581,436.504 c-5.302,3.059-13.542,3.263-18.404,0.454c-4.863-2.808-4.508-7.565,0.794-10.625c5.301-3.059,13.541-3.263,18.405-0.454 C312.238,428.688,311.883,433.444,306.581,436.504z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M292.318,421.69l1.556,2.78c2.995-0.688,6.244-0.752,9.124-0.171l2.099-2.845 C301.064,420.638,296.513,420.727,292.318,421.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M292.318,421.69l1.556,2.78c2.995-0.688,6.244-0.752,9.124-0.171l2.099-2.845 C301.064,420.638,296.513,420.727,292.318,421.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M298.709,420.314c-0.016,0-0.03-0.001-0.045-0.002c-0.411-0.024-0.725-0.377-0.7-0.789 l0.202-3.424l13.786-7.957c0.361-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-13.091,7.554l-0.155,2.623 C299.43,420.008,299.101,420.314,298.709,420.314z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M351.521,400.413c-6.808-3.932-18.344-3.647-25.766,0.636 c-7.422,4.283-7.92,10.943-1.111,14.875c6.808,3.932,18.344,3.647,25.766-0.636 C357.831,411.004,358.329,404.345,351.521,400.413z M346.887,413.253c-5.301,3.059-13.542,3.263-18.404,0.454 c-4.863-2.808-4.508-7.565,0.794-10.625c5.301-3.059,13.542-3.263,18.405-0.454 C352.544,405.437,352.189,410.194,346.887,413.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M332.799,405.117c3.181-1.836,8.125-1.958,11.043-0.272c2.918,1.685,2.704,4.539-0.476,6.375 c-3.181,1.836-8.125,1.958-11.043,0.273C329.405,409.806,329.618,406.952,332.799,405.117z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M332.799,405.117c3.181-1.836,8.125-1.958,11.043-0.272c2.918,1.685,2.704,4.539-0.476,6.375 c-3.181,1.836-8.125,1.958-11.043,0.273C329.405,409.806,329.618,406.952,332.799,405.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M351.521,400.413c-6.808-3.932-18.344-3.647-25.766,0.636 c-7.422,4.283-7.92,10.943-1.111,14.875c6.808,3.932,18.344,3.647,25.766-0.636 C357.831,411.004,358.329,404.345,351.521,400.413z M346.887,413.253c-5.301,3.059-13.542,3.263-18.404,0.454 c-4.863-2.808-4.508-7.565,0.794-10.625c5.301-3.059,13.542-3.263,18.405-0.454 C352.544,405.437,352.189,410.194,346.887,413.253z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M351.521,400.413c-5.753-3.322-14.873-3.622-22.042-1.055l2.46,2.517 c5.121-1.833,11.634-1.618,15.743,0.755c0.752,0.434,1.364,0.919,1.867,1.433l4.589-1.64 C353.432,401.701,352.574,401.021,351.521,400.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M351.521,400.413c-5.753-3.322-14.873-3.622-22.042-1.055l2.46,2.517 c5.121-1.833,11.634-1.618,15.743,0.755c0.752,0.434,1.364,0.919,1.867,1.433l4.589-1.64 C353.432,401.701,352.574,401.021,351.521,400.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M339.129,396.989c-0.015,0-0.03-0.001-0.045-0.002c-0.411-0.024-0.725-0.377-0.7-0.789 l0.203-3.425l13.786-7.956c0.361-0.201,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-13.091,7.553 l-0.156,2.624C339.849,396.682,339.521,396.989,339.129,396.989z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M302.956,448.295c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l76.155-43.945c0.361-0.202,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-76.155,43.945 C303.21,448.263,303.082,448.295,302.956,448.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M307.074,450.663c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l76.155-43.945c0.361-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-76.155,43.945 C307.328,450.63,307.201,450.663,307.074,450.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M311.185,453.036c-0.258,0-0.509-0.134-0.648-0.373c-0.206-0.357-0.083-0.813,0.273-1.02 l76.155-43.945c0.361-0.203,0.813-0.083,1.02,0.273c0.206,0.357,0.083,0.813-0.273,1.02l-76.155,43.945 C311.438,453.003,311.311,453.036,311.185,453.036z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg1);
export default __webpack_public_path__ + "static/media/header-img1.0379b1c8384b0ebc354d85e3703d2df2.svg";
export { ForwardRef as ReactComponent };